import React from "react"
import { Box, Button, Typography } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"

export const MerchantDenied = () => (
  <>
    <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.xl })}>
      <Typography variant="h3">
        <FormattedMessage defaultMessage="Please contact Carrot Care" />
      </Typography>
    </Box>
    <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.md })}>
      <Typography>
        <FormattedMessage defaultMessage="At this time, you won’t be able to use your Carrot Card with this provider. You’ll need to pay for this transaction out-of-pocket and request a reimbursement." />
      </Typography>
    </Box>
    <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.md })}>
      <Typography>
        <FormattedMessage defaultMessage="In the meantime, please contact Carrot Care for further details." />
      </Typography>
    </Box>
    <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.lg })}>
      <div className="flex justify-end">
        <Button component="a" href="/talk-to-carrot">
          <FormattedMessage defaultMessage="Sign in to send a message" />
        </Button>
      </div>
    </Box>
  </>
)
